// ─────────────────────────────────────────────────────────────────────────────
// frontend/src/hooks/useCurrentUser.js
// Hook qui récupère les infos de l'utilisateur connecté depuis /api/user/me/
// ─────────────────────────────────────────────────────────────────────────────
import { useState, useEffect } from "react";
import api from "../api/client";

export function useCurrentUser() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/api/user/me/")
      .then((res) => setUser(res.data))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  return { user, loading };
}


// ─────────────────────────────────────────────────────────────────────────────
// EXEMPLES D'UTILISATION dans tes composants existants
// ─────────────────────────────────────────────────────────────────────────────

// ── 1. Dans la Sidebar (afficher USERNAME) ──────────────────────────────────
//
// import { useCurrentUser } from "../hooks/useCurrentUser";
//
// function Sidebar() {
//   const { user } = useCurrentUser();
//   return (
//     <aside>
//       <img src={logo} alt="Polyglow" />
//       <span className="username">
//         {user?.username || "USERNAME"}
//       </span>
//       {/* ... icônes de navigation ... */}
//     </aside>
//   );
// }


// ── 2. Dans la page Profil (afficher "Hello, Prénom.") ──────────────────────
//
// import { useCurrentUser } from "../hooks/useCurrentUser";
//
// function Profile() {
//   const { user } = useCurrentUser();
//   return (
//     <div>
//       <h1 style={{ fontFamily: "cursive", color: "#D95B2A" }}>
//         Hello, {user?.first_name || user?.username || ""}.
//       </h1>
//       {/* ...reste du profil... */}
//     </div>
//   );
// }


// ── 3. Dans AutoTest / Eval (optionnel, message personnalisé) ───────────────
//
// import { useCurrentUser } from "../hooks/useCurrentUser";
//
// function AutoTest() {
//   const { user } = useCurrentUser();
//   return (
//     <div>
//       <h1>AutoTest</h1>
//       {user && <p>Bonjour {user.name} — {user.xp_points} XP</p>}
//       {/* ...reste du composant... */}
//     </div>
//   );
// }